import { useLocation, useNavigate } from 'react-router-dom';
import './Sidebar.css';

const NAV_ITEMS = [
  { key: 'hub', label: 'Dashboard', icon: '🏛️', path: '/hub' },
  {
    key: 'agreement', label: 'Agreement', icon: '📋', path: '/agreement',
    children: [
      { key: 'saved-drafts', label: 'Saved Drafts', icon: '💾', hash: 'saved-drafts' },
      { key: 'auto-drafts', label: 'Drafts', icon: '📝', hash: 'auto-drafts' },
    ],
  },
  { key: 'customers', label: 'Customers', icon: '🏢', path: '/customers' },
  { key: 'admin', label: 'Admin', icon: '🔐', path: '/admin', adminOnly: true },
];

const ROLE_LABELS = {
  admin: 'Admin',
  manager: 'Manager',
  sales_agent: 'Sales Agent',
  viewer: 'Viewer',
};

function Sidebar({ currentUser }) {
  const location = useLocation();
  const navigate = useNavigate();

  const items = NAV_ITEMS.filter(item => !item.adminOnly || currentUser?.role === 'admin');
  const roleLabel = currentUser ? (ROLE_LABELS[currentUser.role] || currentUser.role) : '';

  return (
    <aside className="app-sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-logo">AM</div>
        <div className="sidebar-brand-text">
          <span className="sidebar-brand-main">AL MUSHTARAKA</span>
          <span className="sidebar-brand-sub">Trading Co.</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {items.map((item) => (
          <div key={item.key} className="sidebar-nav-group">
            <button
              className={`sidebar-nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
              title={item.label}
            >
              <span className="sidebar-nav-icon">{item.icon}</span>
              <span className="sidebar-nav-label">{item.label}</span>
            </button>
            {item.children && location.pathname === item.path && (
              <div className="sidebar-nav-children">
                {item.children.map((child) => (
                  <button
                    key={child.key}
                    className={`sidebar-nav-subitem ${location.hash === `#${child.hash}` ? 'active' : ''}`}
                    onClick={() => navigate(`${item.path}#${child.hash}`)}
                    title={child.label}
                  >
                    <span className="sidebar-nav-icon">{child.icon}</span>
                    <span className="sidebar-nav-label">{child.label}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user" title={`${currentUser?.name} — ${roleLabel}`}>
          <div className="sidebar-user-avatar">{currentUser?.name?.charAt(0).toUpperCase()}</div>
          <div className="sidebar-user-info">
            <span className="sidebar-user-name">{currentUser?.name}</span>
            <span className="sidebar-user-role">{roleLabel}</span>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
